import { Outlet } from 'react-router-dom';

import { MobileHeader } from './MobileHeader';
import { Sidebar } from './Sidebar';

import type { ReactNode } from 'react';

export function Shell(): ReactNode {
  return (
    <div className="flex min-h-screen bg-void">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <MobileHeader />
        <main className="flex-1 overflow-auto">
          <div className="p-6 md:p-12 max-w-[1400px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
